<template>
  <v-card
    outlined
    class="my-2"
    loader-height="8"
    :loading="admin.productAccessorysLoading"
    :disabled="admin.productAccessorysLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-dialog v-model="showConfirmationDialog" max-width="450">
      <v-card>
        <v-card-title
          ><v-icon class="mr-2" color="yellow darken-2"> mdi-alert </v-icon
          >CONFIRM</v-card-title
        >
        <v-card-text class="text-h5">
          Delete Accessory ({{ id }})?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="deleteProductAccessory">
            <v-icon> mdi-check-bold </v-icon>
          </v-btn>
          <v-btn
            color="error lighten-1"
            @click="showConfirmationDialog = false"
          >
            <v-icon> mdi-cancel </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar color="blue lighten-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.detailIcon }}</v-icon>
    </v-toolbar>
    <v-card-text v-show="admin.selectedProductAccessory == null"></v-card-text>
    <v-card-text v-show="admin.selectedProductAccessory != null">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Accessory saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field disabled v-model="id" label="ID" readonly></v-text-field>
        <v-autocomplete
          :items="admin.productList"
          label="Product"
          outlined
          item-text="sku"
          item-value="id"
          v-model="productId"
          :rules="validation.selection"
          autofocus
        ></v-autocomplete>
        <v-text-field
          v-model="minQuantity"
          :rules="validation.Numeric"
          label="Min Quantity"
          required
        ></v-text-field>
        <v-text-field
          v-model="maxQuantity"
          :rules="validation.Numeric"
          label="Max Quantity"
          required
        ></v-text-field>
        <v-checkbox
          color="blue darken-2"
          v-model="required"
          label="Required"
        ></v-checkbox>
        <v-checkbox
          color="blue darken-2"
          v-model="defaultToParentQuantity"
          label="Default to Parent Qty"
        ></v-checkbox>
        <v-checkbox
          color="blue darken-2"
          v-model="configurable"
          label="Configurable"
        ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions v-show="admin.selectedProductAccessory != null">
      <v-spacer />
      <v-btn
        dark
        color="blue darken-2"
        @click="saveProductAccessory"
        :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="cancelCreation">cancel</v-btn>
      <v-btn
        v-show="!isNaN(id)"
        icon
        color="error"
        @click="confirmDeleteAccessory"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        showSaveOverlay: false,
        showConfirmationDialog: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      tabName: {
        get() {
          let tabName = 'Edit';
          if (
            this.admin.selectedProductAccessory &&
            this.admin.selectedProductAccessory.id != 'new'
          ) {
            tabName = 'Edit Accessory';
          } else if (
            this.admin.selectedProductAccessory &&
            this.admin.selectedProductAccessory.id == 'new'
          ) {
            tabName = 'Add New Accessory';
          }
          return tabName;
        }
      },
      id: {
        get() {
          return this.admin.selectedProductAccessory?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductAccessory',
            property: 'id',
            value: value
          });
        }
      },
      productId: {
        get() {
          return this.admin.selectedProductAccessory?.productId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductAccessory',
            property: 'productId',
            value: value
          });
        }
      },
      minQuantity: {
        get() {
          return this.admin.selectedProductAccessory?.minQuantity;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductAccessory',
            property: 'minQuantity',
            value: Number(value)
          });
        }
      },
      maxQuantity: {
        get() {
          return this.admin.selectedProductAccessory?.maxQuantity;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductAccessory',
            property: 'maxQuantity',
            value: Number(value)
          });
        }
      },
      required: {
        get() {
          return this.admin.selectedProductAccessory?.required;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductAccessory',
            property: 'required',
            value: value
          });
        }
      },
      configurable: {
        get() {
          return this.admin.selectedProductAccessory?.configurable;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductAccessory',
            property: 'configurable',
            value: value
          });
        }
      },
      defaultToParentQuantity: {
        get() {
          return this.admin.selectedProductAccessory?.defaultToParentQuantity;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProductAccessory',
            property: 'defaultToParentQuantity',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Cancels upsert of a product
       */
      cancelCreation() {
        this.$store.commit('admin/setSelectedProductAccessory', null);
      },
      /**
       * Saves the product currently being edited
       */
      saveProductAccessory() {
        this.$store.dispatch('admin/saveSelectedProductAccessory').then(() => {
          this.showSaveOverlay = true;
          // refresh product list
          this.$store.dispatch('admin/getProductAccessoryList');
          setTimeout(() => {
            this.showSaveOverlay = false;
            this.$store.commit('admin/setSelectedProductAccessory', null);
          }, 1500);
        });
      },
      /**
       * Show confirm dialog
       */
      confirmDeleteAccessory() {
        this.showConfirmationDialog = true;
      },
      /**
       * Deletes a a product accessory
       */
      deleteProductAccessory() {
        this.$store
          .dispatch('admin/deleteProductAccessory', this.id)
          .then(() => {
            this.$store.dispatch('admin/getProductAccessoryList');
            this.showConfirmationDialog = false;
            this.$store.commit('admin/setSelectedProductAccessory', null);
          });
      }
    }
  };
</script>

<style scoped></style>
